import { transferSection as _transferSection } from '@griply/services';
import { LinkOptions, SectionContainer } from '@griply/types';
import {
  collection,
  doc,
  Firestore,
  serverTimestamp,
  writeBatch,
} from 'firebase/firestore';
import {
  FirestoreWriteOp,
  logFirestoreWriteError,
} from 'shared/services/error-tracking';
import { ID } from 'shared/types/id';
import { chunkArray } from 'shared/utils/chunk-array';

import { getTaskDocs } from './get-tasks';
import { getDatabase } from './helpers';

export type TransferSectionInput = {
  sectionId: ID;
  from: SectionContainer;
  fromType: LinkOptions;
  to: SectionContainer;
  toType: LinkOptions;
};

export const transferSection = async ({
  sectionId,
  from,
  fromType,
  to,
  toType,
}: TransferSectionInput) => {
  const section = from.sections?.find(({ id }) => id === sectionId);
  if (!section) {
    return;
  }

  const tasks = (
    await Promise.all(
      chunkArray(section.tasks, 30).map((ids) => getTaskDocs({ ids })),
    )
  ).flat(1);

  return _transferSection({
    sectionId,
    from,
    fromType,
    to,
    toType,
    tasks,
    collection,
    doc,
    db: getDatabase(),
    serverTimestamp,
    writeBatch: (db) => writeBatch(db as Firestore),
    onWriteError: (error) =>
      logFirestoreWriteError({
        op: FirestoreWriteOp.TransferSection,
        error,
      }),
  });
};
